import { gsap } from 'gsap'

function initFooterAnimate() {
  const footerEl = document.querySelector('.js-animate-footer')

  const footerAnimation = () => {
    gsap.to(footerEl, {
      y: '0',
      duration: 0.5,
    })
  }

  setTimeout(() => {
    footerAnimation()
  }, 500)
}
initFooterAnimate()
